import React from "react";
import { Box, FormLabel, FormControlLabel, Radio, RadioGroup } from "@material-ui/core";
import useCatalogsSwr from "hooks/useCatalogsSwr";

function CatalogSelection({ selectedCatalogs = [], setSelectedCatalogs = () => {} }) {
    const { catalogs = [] } = useCatalogsSwr();

    // Filtra duplicados por catalogName
    const uniqueCatalogs = Object.values(
        catalogs.reduce((acc, catalog) => {
            if (!acc[catalog.catalogName]) {
                acc[catalog.catalogName] = catalog;
            }
            return acc;
        }, {})
    );

    const handleCatalogChange = (event) => {
        setSelectedCatalogs([event.target.value]);
    };

    return (
        <Box display="flex" flexDirection="column">
            <FormLabel
                component="legend"
                color="secondary"
                style={{ marginBottom: "0px", fontWeight: "bold" }}
            >
                Catalog
            </FormLabel>

            <RadioGroup row value={selectedCatalogs[0] || ""} onChange={handleCatalogChange}>
                {uniqueCatalogs.map((catalog) => (
                    <FormControlLabel
                        key={catalog.catalogName}
                        value={catalog.catalogName}
                        control={<Radio color="primary" />}
                        label={catalog.displayName}
                    />
                ))}
            </RadioGroup>
        </Box>
    );
}

export default CatalogSelection;
